import React, { useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';

const LoginPage: React.FC = () => {
  console.info('LoginPage mounted');
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const autoLogin = searchParams.get('auto') === 'true';

  useEffect(() => {
    // Always clean up session storage flags when landing on the login page
    // to prevent getting stuck in "logging out" state.
    if (!isAuthenticated) {
      console.info('Cleaning up auth flags on LoginPage');
      sessionStorage.removeItem('auth_redirect_in_progress');
      sessionStorage.removeItem('is_logging_out');
    }

    // If user is already authenticated, redirect them
    if (isAuthenticated) {
      // Get returnTo from URL params or appState
      console.info('User is authenticated');
      const returnTo = searchParams.get('returnTo') ||
        JSON.parse(sessionStorage.getItem('auth_redirect_in_progress') || '{}')?.returnTo ||
        '/search';

      // Clean up session storage before redirecting
      sessionStorage.removeItem('auth_redirect_in_progress');
      sessionStorage.removeItem('is_logging_out');

      // Redirect to the appropriate page
      console.log('Redirecting to:', returnTo);
      navigate(returnTo, { replace: true });
      return;
    }
    // Handle auto-login if specified
    if (!isAuthenticated && autoLogin) {
      console.info('Auto-login initiated');
      loginWithRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, navigate, autoLogin, loginWithRedirect, searchParams]);

  // If user is authenticated, don't render the login page
  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh'
    }}>
      <h1>Welcome to FuturX</h1>
      <p>Please log in to continue</p>
      <Button
        type="primary"
        size="large"
        onClick={() => {
          console.info('Login button clicked');
          loginWithRedirect();
        }}
        loading={isLoading}
      >
        Log In
      </Button>
    </div>
  );
};

export default LoginPage; 